import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { GlameraSharedService } from '../services/glamera-shared.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private sharedService: GlameraSharedService ,
    private cookieService: CookieService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,

  ): Observable<HttpEvent<any>> {

    const token = this.sharedService.token;

    if(!token){
      // debugger;


      // const currentUrl = window.location.href;
      // const encodedUrl = btoa(currentUrl);
      // const loginUrl = `${environment.LoginURL}`;

      window.location.href = environment.LoginURL;



      // window.location.href = environment.saasURL + '/login';
      return new Observable<HttpEvent<any>>();
    }
    const modifiedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(modifiedRequest);
  }
}
